import React, { useState , useEffect} from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './MasikShiv.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import axios from 'axios';
import city from '../../../city.json'



const deities = {
  "Lord Vishnu": {
    name: "Lord Vishnu",
    significance:
      "Lord Vishnu is regarded as the preserver and protector of the universe in Hinduism. He is part of the Holy Trinity (Trimurti) along with Brahma and Shiva.",
    mythology:
      "According to Hindu scriptures, Lord Vishnu incarnates on Earth whenever there is a decline in Dharma (righteousness) to restore cosmic order.",
    symbols: [
      "Conch (Shankha)",
      "Discus (Chakra)",
      "Lotus (Padma)",
      "Mace (Gada)",
    ],
    culturalAspect:
      "Lord Vishnu is worshipped by millions, especially in Vaishnavism traditions. Festivals include Janmashtami, Ram Navami, and Vaikuntha Ekadashi.",
  },
  "Lord Brahma": {
    name: "Lord Brahma",
    significance:
      "Lord Brahma is the creator in Hinduism, responsible for the creation of the universe and all living beings.",
    mythology:
      "Brahma emerged from a lotus growing from Lord Vishnu’s navel. He is rarely worshipped, with Pushkar temple being one of the few dedicated to him.",
    symbols: ["Vedas", "Kamandalu (water pot)", "Lotus", "Beard (symbol of wisdom)"],
    culturalAspect:
      "Though one of the Trimurti, Brahma has fewer temples compared to Vishnu and Shiva.",
  },
  "Goddess Lakshmi": {
    name: "Goddess Lakshmi",
    significance: "Lakshmi is the goddess of wealth, prosperity, and fortune.",
    mythology:
      "She emerged from the churning of the cosmic ocean (Samudra Manthan) and chose Lord Vishnu as her consort.",
    symbols: ["Lotus", "Gold coins", "Elephants"],
    culturalAspect:
      "She is worshipped during Diwali and Fridays are considered auspicious for her worship.",
  },
  Indrani: {
    name: "Indrani",
    significance: "Indrani is the queen of the gods, wife of Indra, and goddess of jealousy and wrath.",
    mythology:
      "She is known for her beauty and association with the Airavata elephant.",
    symbols: ["Elephant", "Lotus", "Thunderbolt"],
    culturalAspect:
      "Indrani is mentioned in Rigveda and often seen as a powerful consort of Indra.",
  },
  Saraswati: {
    name: "Saraswati",
    significance: "Goddess of wisdom, knowledge, and arts.",
    mythology:
      "She is the consort of Brahma and often depicted playing the veena.",
    symbols: ["Veena", "Swan", "White lotus"],
    culturalAspect:
      "Worshipped during Vasant Panchami and by students/artists across India.",
  },
  Gayatri: {
    name: "Gayatri",
    significance: "Gayatri Devi is considered the personification of the Gayatri mantra.",
    mythology:
      "She is revered as the goddess of Vedic knowledge and the mother of all Vedas.",
    symbols: ["Five faces", "Lotus", "Book"],
    culturalAspect:
      "Reciting the Gayatri mantra daily is believed to purify the mind and soul.",
  },
  Savitri: {
    name: "Savitri",
    significance:
      "Savitri is revered as a goddess of fidelity and devotion, known for her dedication to her husband Satyavan.",
    mythology:
      "Her story in Mahabharata highlights her defeating Yama, the god of death, with wisdom and devotion.",
    symbols: ["Lotus", "Veena"],
    culturalAspect:
      "Worshipped by married women in the Savitri Vrat for long life of their husbands.",
  },
  Sita: {
    name: "Sita",
    significance:
      "Sita is the consort of Lord Rama and an avatar of Goddess Lakshmi.",
    mythology:
      "Her story in the Ramayana embodies devotion, sacrifice, and purity.",
    symbols: ["Lotus", "Bow (as in Sita Swayamvar)"],
    culturalAspect:
      "Worshipped widely as a symbol of ideal womanhood and marital devotion.",
  },
  Parvati: {
    name: "Parvati",
    significance:
      "Parvati is the goddess of love, fertility, and devotion, and the consort of Lord Shiva.",
    mythology:
      "She is also known as Shakti, Durga, and Kali in her various forms.",
    symbols: ["Trident", "Lion", "Lotus"],
    culturalAspect:
      "Navratri and Teej festivals celebrate her devotion and power.",
  },
};


const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};

const MasikShiv = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('New Delhi, India');
  const [timeFormat, setTimeFormat] = useState('12');

  const [shivList, setShivList] = useState([]);
  const [selectedShiv, setSelectedShiv] = useState(null);


  const [popupDeity, setPopupDeity] = useState(null);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const shivaratriTooltips = {
  "Masik Shivaratri": "Masik Shivaratri is a monthly observance dedicated to Lord Shiva, occurring on the Krishna Paksha Chaturdashi. Devotees observe fasting and night-long vigil to seek blessings for spiritual growth and removal of negativity.",
  "Sawan Shivaratri": "Sawan Shivaratri is considered highly auspicious as it falls during the holy month of Shravan, a period especially dedicated to Lord Shiva. Fasting and Rudrabhishek rituals on this day are believed to fulfill wishes and grant peace.",
  "Maha Shivaratri": "Maha Shivaratri is the grand annual night of Shiva, observed with great devotion across India. It signifies the cosmic dance of Shiva and the convergence of Shiva and Shakti. Devotees fast, chant, and perform night-long worship to gain divine grace."
};


useEffect(() => {
  const fetchShivData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/shivaratri?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.shivaratriDates) {
        setShivList(response.data.shivaratriDates);
      } else {
        setShivList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch shiv data:", error);
      setShivList([]);
    }
  };

  fetchShivData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="MasikShiv-container">
      <InnerNav />
      <div className="MasikShiv-content">
        <Zodiac />

        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Masik Shivaratri Puja Dates</h2>
              <div className="current-ekadashi">
                <img
                  src="https://www.financialexpress.com/wp-content/uploads/2024/03/shivratri-1200x675-1.jpg"
                  alt="Satya Puja"
                  className="moon-preview"
                />
                <div>
                 
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="Shiv-controls">
                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedShiv ? (
  <div className="shiv-list">
    {shivList.length === 0 && (
      <p>No shivaratri puja data available for selected year/location.</p>
    )}

    {shivList.map((item, idx) => (
      <div
        className="shiv-item clickable"
        key={idx}
        onClick={() => setSelectedShiv(item)}
      >
        <img
          src="https://st5.depositphotos.com/1820591/78607/v/450/depositphotos_786071164-stock-illustration-happy-maha-shivratri-beautiful-indian.jpg"
          alt={item.title}
        />

        <div className="shiv-details">
          <p className="shiv-date">{item.date}</p>
          <div className="shiv-name">{item.title}</div>
          <p className="shiv-phase">{item.muhurta}</p>
          <p className="shiv-tithi">{item.tithiName}</p>
          <p className="shiv-tithi">{item.duration}</p>
        </div>

        <div className="shiv-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="shiv-detail-view">
    <button className="back-btn" onClick={() => setSelectedShiv(null)}>
      ← Back
    </button>

    <h2 className="detail-title">{selectedShiv.title}</h2>

    <img
      className="detail-image"
      src="https://st5.depositphotos.com/1820591/78607/v/450/depositphotos_786071164-stock-illustration-happy-maha-shivratri-beautiful-indian.jpg"
      alt={selectedShiv.title}
    />

    {/* BASIC DETAILS */}
    <div className="detail-section">
      <h3>📅 Event Details</h3>
      <p><strong>Date:</strong> {selectedShiv.date}</p>
      <p><strong>Muhurta:</strong> {selectedShiv.muhurta}</p>
      <p><strong>Tithi:</strong> {selectedShiv.tithiName}</p>
      <p><strong>Duration:</strong> {selectedShiv.duration}</p>
    </div>

    {/* TIME DETAILS */}
    <div className="detail-section">
      <h3>⏰ Timing Information</h3>
      <p><strong>Tithi Start:</strong> {formatTime(selectedShiv.tithiStart, timeFormat)}</p>
      <p><strong>Tithi End:</strong> {formatTime(selectedShiv.tithiEnd, timeFormat)}</p>
    </div>

    {/* LUNAR DETAILS */}
    <div className="detail-section">
      <h3>🌙 Lunar Information</h3>
      <p>{selectedShiv.lunarDetail}</p>
    </div>

    {/* SIGNIFICANCE */}
    <div className="detail-section">
      <h3>🕉️ Significance</h3>
      <p>
        {shivaratriTooltips[selectedShiv.title] ||
          "Masik Shivaratri is observed to seek Lord Shiva’s blessings for inner peace, strength, and removal of obstacles."}
      </p>
    </div>
  </div>
)
}

        </div>

         <section className="masikshivaratri-wrapper">
      <h1 className="masikshivaratri-title">Masik Shivaratri</h1>
      <div className="masikshivaratri-texts">
        <p>
          Shivaratri is great festival of convergence of Shiva and Shakti. Each month, Chaturdashi Tithi during Krishna Paksha is known as Masik Shivaratri.
        </p>

        <p>
          Masik Shivaratri in month of Magha is known as Maha Shivaratri according to Amanta School. However according to Purnimanta School Masik Shivaratri in month of Phalguna is known as Maha Shivaratri. In both schools it is naming convention of lunar month which differs. However both, Purnimanta and Amanta Schools, celebrate all Shivaratris including Maha Shivaratri on same day.
        </p>

        <p>
          According to Indian Mythology, in the midnight of Maha Shivaratri, Lord Shiva was appeared in form of Linga. Shiva Linga was first worshipped by 
          <span className="popup-link" onClick={() => setPopupDeity('Lord Vishnu')}> Lord Vishnu</span>  
           and 
          <span className="popup-link" onClick={() => setPopupDeity('Lord Brahma')}>Lord Brahma</span> 
           
          Hence Maha Shivaratri is known as birthday of Lord Shiva and devotees worship Shiva Linga during Shivaratri. Shivaratri Vrat is popular since ancient time. In Hindu Puranas we get references of Shivaratri Vrat. According to scriptures even 
          <span className="popup-link" onClick={() => setPopupDeity('Goddess Lakshmi')}>Goddess Lakshmi,</span> 
          <span className="popup-link" onClick={() => setPopupDeity('Indrani')}>Indrani,</span> 
          <span className="popup-link" onClick={() => setPopupDeity('Saraswati')}>Saraswati,</span> 
            <span className="popup-link" onClick={() => setPopupDeity('Gayatri')}>Gayatri,</span>
            <span className="popup-link" onClick={() => setPopupDeity('Savitri')}>Savitri,</span>
           <span className="popup-link" onClick={() => setPopupDeity('Sita')}>Sita,</span>
           <span className="popup-link" onClick={() => setPopupDeity('Parvati')}>Parvati</span>
           Rati observed Shivaratri fast.
        </p>

        <p>
          Devotees, who want to observe Masik Shivaratri Vrat, can start it from Maha Shivaratri day and continue it for a year. It is believed that impossible and difficult task can be fulfilled by observing Masik Shivaratri Vrats by the grace of Lord Shiva. Devotees should keep awake during Shivaratri and perform Shiva Puja during midnight. Unmarried women observe this fast to get married and married women observe this fast to maintain peace and tranquility in their married life.
        </p>

        <p>
          Masik Shivaratri when falls on Tuesday becomes highly auspicious. Shivaratri Pujan is suggested during midnight which is known as Nishita Kaal and prevails for two Ghati.
        </p>

        <p>
          Lord Shiva is also known as Bholenath due to his gullible nature.
        </p>
      </div>
    </section>
        <VratLinks/>
      </div>
      <Footer />
            {popupDeity && (
  <div className="popup-overlay" onClick={() => setPopupDeity(null)}>
    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
      <h2>{deities[popupDeity].name}</h2>
      <p><strong>Significance:</strong> {deities[popupDeity].significance}</p>
      <p><strong>Mythology:</strong> {deities[popupDeity].mythology}</p>

      <h3>Symbols</h3>
      <ul>
        {deities[popupDeity].symbols.map((symbol, idx) => (
          <li key={idx}>{symbol}</li>
        ))}
      </ul>

      <p><strong>Cultural Aspect:</strong> {deities[popupDeity].culturalAspect}</p>

      <button className="close-btn" onClick={() => setPopupDeity(null)}>Close</button>
    </div>
  </div>
)}
    </div>
  );
};

export default MasikShiv;
